import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsContext } from "../types";

const SpaceDetailsContextsNameCell = ({
  item: context,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsContext>) => (
  <TableSimpleCell {...cellProps} role="rowheader">
    <TableCellLink href={`/context/${context.id}`}>{context.name}</TableCellLink>
  </TableSimpleCell>
);

export default SpaceDetailsContextsNameCell;
